module.exports = __webpack_public_path__ + "assets/img/678bde1607cd851df752a791af8f7154.png";